import { Injectable } from '@angular/core';
import { Http, Request, RequestOptions, ConnectionBackend, RequestMethod, RequestOptionsArgs, Headers } from '@angular/http';

import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/timeout';

import { CONFIGURATION } from '../configuration/configuration';
import { URL_SERVICE } from '../../../environments/environment';
import { API_ENDPOINTS } from '../configuration/api-endpoints';
import { STATIC_VALUE } from '../configuration/static.value';

import { PageNavigationService } from './page-navigation.service';
import { StorageService } from './storage.service';
import { EncryptionService } from './encryption.service';


@Injectable()
export class MyHttp extends Http {
    serviceBase: string;
    timeout: number;

    sslServer: string;
    sslFinger: string;

    private vHttpPendingRequestEvent: Array<any>;
    private vIsRetrying: boolean;

    constructor(
        backend: ConnectionBackend,
        defaultOptions: RequestOptions,
        private _pageNavigationService: PageNavigationService,
        private _storageService: StorageService,
        private _encryptionService: EncryptionService) {

        super(backend, defaultOptions);

        this.serviceBase = URL_SERVICE[CONFIGURATION.modeEnv].BASE_URL;
        this.timeout = CONFIGURATION.SERVICE.TIME_OUT;

        this.vHttpPendingRequestEvent = new Array<Function>();
        this.vIsRetrying = false;

    }

    public get(url: string, options?: RequestOptionsArgs) {
        console.log('https get connection');
        return this._request(RequestMethod.Get, url, null, options);
    }

    public post(url: string, body: string, options?: RequestOptionsArgs) {
        console.log('Post');
        return this._request(RequestMethod.Post, url, body, options);
    }

    public put(url: string, body: string, options?: RequestOptionsArgs) {
        return this._request(RequestMethod.Put, url, body, options);
    }

    public delete(url: string, options?: RequestOptionsArgs) {
        return this._request(RequestMethod.Delete, url, null, options);
    }

    private _createAuthHeaders(method: RequestMethod, url): Headers {
        let headers: Headers = new Headers();
        if (method !== RequestMethod.Get) {
            headers.append(STATIC_VALUE.HTTP_HEADER.CONTENT_TYPE, 'application/json');
        }

        // let accessToken = localStorage.getItem('accessToken');
        if (url.indexOf(API_ENDPOINTS.ACCOUNT.CHANGE_PASSWORD) !== -1) {
            let accessToken = this._storageService.getToken('accessToken');
            if (accessToken) {
                headers.append(STATIC_VALUE.HTTP_HEADER.AUTH, 'Bearer ' + accessToken);
            }
        } else {
            let accessToken = this._storageService.getToken('idToken');
            if (accessToken) {
                headers.append(STATIC_VALUE.HTTP_HEADER.AUTH, 'Bearer ' + accessToken);
            }
        }


        // headers.append(STATIC_VALUE.HTTP_HEADER.CHANNEL, 'web');

        return headers;
    }

    private _createNoCacheHeaders(method: RequestMethod, url, headers: Headers): Headers {
        headers.append('Cache-control', 'no-cache');
        headers.append('Cache-control', 'no-store');
        headers.append('Expires', '0');
        headers.append('Pragma', 'no-cache');

        return headers;
    }

    private handleHTTPError(pError, pObserver) {
        switch (pError.code) {
            case 408: // timeout
                pObserver.error(pError);
                break;
            case 400: // system error
                pObserver.error(pError);
                break;
            case 500: // functional error
                pObserver.error(pError);
                break;
            case 502: // BAD GATEWAY
                pObserver.error(pError);
                break;
            case 452: // MAINTENANCE MODE
                pObserver.error(pError);
                break;
            case 453: // MAINTENANCE MODE SPECIFIC
                pObserver.error(pError);
                break;
            default:
                // throw error
                pObserver.error(pError);
                break;
        }
    }

    private _request(method: RequestMethod, url: string, body?: string, options?: RequestOptionsArgs): Observable<any> {

        let bodyString;

        if (method === RequestMethod.Post) {
            if (CONFIGURATION.ENCRYPTION.REQUEST && url.indexOf('dms') === -1) {
                let bodyJson = {
                    body: this._encryptionService.encrypt(JSON.stringify(body))
                }
                bodyString = JSON.stringify(bodyJson);
           } else {
                bodyString = body;
            }
        }

        let requestOptions = new RequestOptions({
            method: method,
            body: bodyString
        });
        // using custom options
        if (options) {
            for (let attrname in options) {
                requestOptions[attrname] = options[attrname];
            }
        } else if (url.indexOf('https://developers.onemap.sg/commonapi/search') === -1) {
            requestOptions.headers = this._createAuthHeaders(method, url);
            requestOptions.headers = this._createNoCacheHeaders(method, url, requestOptions.headers);
        }

        if (url.indexOf('googleapis') !== -1) {
            requestOptions.url = url;
        } else if (url.indexOf('onemap') !== -1) {
            requestOptions.url = url;
        } else if (url.indexOf('dms') !== -1) {
            requestOptions.url = url

        } else {
            requestOptions.url = this.serviceBase + url;
        }

        console.log('api url: ' + requestOptions.url);
        return Observable.create((observer) => {
            let currentContext = this;
            let requestObject: Request = new Request(requestOptions);
            this.request(requestObject).timeout(this.timeout).subscribe(
                (response) => {
                    console.log(requestOptions.url);
                    console.log(requestOptions.url.indexOf('onemap'));
                    if (CONFIGURATION.ENCRYPTION.REQUEST && requestOptions.url.indexOf('onemap') === -1 ) {
                        if(requestOptions.url.indexOf('dms') != -1)
                        {
                        let payload = response.arrayBuffer();
                        observer.next(payload);
                        observer.complete();
                        }
                        else{
                        let payload = this._encryptionService.decrypt(response.text());
                        observer.next(JSON.parse(payload));
                        observer.complete();
                        }
                    } else {
                        observer.next(response.json());
                        observer.complete();
                    }

                },
                (error) => {
                    switch (error.status) {

                        case 403:
                            try {
                                // request to get access token for the first time
                                // should not get error 403
                                if (requestOptions.url.indexOf('token') !== -1) {
                                    observer.error(error); // prepare send back to login
                                } else {
                                    // caused by invalid token sent to server
                                    // push pending request
                                    this.pushRetryHTTPRequestEvent(requestObject, observer);
                                    // try access once again using refresh token
                                    // only need to make one call to refresh token
                                    if (!currentContext.vIsRetrying) {
                                        currentContext.vIsRetrying = true;
                                        this.renewToken();
                                    }
                                }
                                break;
                            } catch (pErr) {
                                break;
                            }
                        case 401:
                            try {
                                // appvalidation failed
                                // show error message and back to login page
                                if (CONFIGURATION.ENCRYPTION.REQUEST) {
                                    let payload = this._encryptionService.decrypt(error.text());
                                    this.handleHTTPError(JSON.parse(payload), observer);
                                } else {
                                    this.handleHTTPError(error.json(), observer);
                                }
                                // this.handleHTTPError(error, observer);
                                break;
                            } catch (pErr) {
                                break;
                            }
                        case 502:
                            try {
                                this.handleHTTPError({ code: 502, desc: 'Something went wrong. Please try again later' }, observer);
                                break;
                            } catch (pErr) {
                                break;
                            }
                        case undefined:
                            try {
                                this.handleHTTPError({ code: 502, desc: 'Something went wrong. Please try again later' }, observer);
                                break;
                            } catch (pErr) {
                                break;
                            }
                        default:
                            let vError = error;
                            console.log(error.status);
                            console.log(vError.text());
                            if (error.status == 0) {
                                this.handleHTTPError({ code: 0, desc: 'No connection' }, observer);
                            } else {
                                if (CONFIGURATION.ENCRYPTION.REQUEST) {
                                    let payload = this._encryptionService.decrypt(error.text());
                                    console.log(payload);
                                    this.handleHTTPError(JSON.parse(payload), observer);
                                } else {
                                    this.handleHTTPError(error.json(), observer);
                                }
                            }
                            break;
                    }
                });
        });
    }

    // handling for paralel request of refresh token
    private executePendingRequest(pRequestObject: Request, pObservableInstance: any) {
        // update the header with new accessToken
        // console.log(pRequestObject);console.log(pObservableInstance);
        pRequestObject.headers = this._createAuthHeaders(pRequestObject.method, pRequestObject.url);
        pRequestObject.headers = this._createNoCacheHeaders(pRequestObject.method, pRequestObject.url, pRequestObject.headers);
        // console.log('pop : ' + pRequestObject.url + ' pending request from stack');
        // retry previous request
        // this.request(pRequestObject).timeout(this.timeout).subscribe(
        //     (response) => {
        //         pObservableInstance.next(response);
        //         pObservableInstance.complete();
        //     },
        //     (error) => {
        //         this.handleHTTPError(error, pObservableInstance);
        //     }
        // );
        let currentContext = this;
        this.request(pRequestObject).timeout(this.timeout).subscribe(
            (response) => {
                console.log(pRequestObject.url);
                console.log(pRequestObject.url.indexOf('onemap'));
                if (CONFIGURATION.ENCRYPTION.REQUEST && pRequestObject.url.indexOf('onemap') === -1) {
                    let payload = this._encryptionService.decrypt(response.text());
                    pObservableInstance.next(JSON.parse(payload));
                    pObservableInstance.complete();
                } else {
                    pObservableInstance.next(response.json());
                    pObservableInstance.complete();
                }

            },
            (error) => {
                switch (error.status) {

                    case 403:
                        try {
                            // request to get access token for the first time
                            // should not get error 403
                            if (pRequestObject.url.indexOf('token') !== -1) {
                                pObservableInstance.error(error); // prepare send back to login
                            } else {
                                // caused by invalid token sent to server
                                // push pending request
                                this.pushRetryHTTPRequestEvent(pRequestObject, pObservableInstance);
                                // try access once again using refresh token
                                // only need to make one call to refresh token
                                if (!currentContext.vIsRetrying) {
                                    currentContext.vIsRetrying = true;
                                    this.renewToken();
                                }
                            }
                            break;
                        } catch (pErr) {
                            break;
                        }
                    case 401:
                        try {
                            // appvalidation failed
                            // show error message and back to login page
                            if (CONFIGURATION.ENCRYPTION.REQUEST) {
                                let payload = this._encryptionService.decrypt(error.text());
                                this.handleHTTPError(JSON.parse(payload), pObservableInstance);
                            } else {
                                this.handleHTTPError(error.json(), pObservableInstance);
                            }
                            // this.handleHTTPError(error, observer);
                            break;
                        } catch (pErr) {
                            break;
                        }
                    case 502:
                        try {
                            this.handleHTTPError({ code: 502, desc: 'Something went wrong. Please try again later' }, pObservableInstance);
                            break;
                        } catch (pErr) {
                            break;
                        }
                    case undefined:
                        try {
                            this.handleHTTPError({ code: 502, desc: 'Something went wrong. Please try again later' }, pObservableInstance);
                            break;
                        } catch (pErr) {
                            break;
                        }
                    default:
                        let vError = error;
                        console.log(error.status);
                        console.log(vError.text());
                        if (error.status == 0) {
                            this.handleHTTPError({ code: 0, desc: 'No connection' }, pObservableInstance);
                        } else {
                            if (CONFIGURATION.ENCRYPTION.REQUEST) {
                                let payload = this._encryptionService.decrypt(error.text());
                                console.log(payload);
                                this.handleHTTPError(JSON.parse(payload), pObservableInstance);
                            } else {
                                this.handleHTTPError(error.json(), pObservableInstance);
                            }

                        }
                        break;
                }
            });
    }

    private pushRetryHTTPRequestEvent(pRequestObject: Request, pObservablesInstance: any) {

        let vPendingRequestObject = {
            request: pRequestObject,
            observables: pObservablesInstance
        };
        this.vHttpPendingRequestEvent.push(vPendingRequestObject);
    }

    private renewToken() {

        // TODO: add function to refresh access token
        // Note: we are using AWS Cognito. All function from get token to logout using Cognito function

        // if succesfully get access token and id token
        // run this code:
        // execute all pending retry request
        // this.vHttpPendingRequestEvent.forEach(function (pRequestEvent, pIndex, pObject) {
        //     vCurrentContext.executePendingRequest(pRequestEvent.request, pRequestEvent.observables);
        // });
        // this.vHttpPendingRequestEvent = [];
        // dont forget to add new access token and id token to sessionStorage

        // if unable to get access token and id token
        // remove token on storage and call logout function from Cognito

        let personalData = this._storageService.getLocalItem('personalData');
        let username;
        if (personalData !== null) {
            username = JSON.parse(personalData).username;
        }

        let vURL: string = this.serviceBase + API_ENDPOINTS.AUTH.REFRESH + '?username=' + username;
        let refreshToken: string = this._storageService.getToken('refreshToken');
        // let refreshToken: string = this._encryptionService.decrypt(localStorage.getItem('refreshToken'));
        // let body: string = this._encryptionService.encrypt(JSON.stringify(refreshToken));

        let vRequestHeader = new Headers();
        vRequestHeader.append(STATIC_VALUE.HTTP_HEADER.CONTENT_TYPE, 'text/plain');
        if (refreshToken) {
            vRequestHeader.append(STATIC_VALUE.HTTP_HEADER.AUTH, 'Bearer ' + refreshToken);
        }
        // vRequestHeader.append(STATIC_VALUE.HTTP_HEADER.CHANNEL, 'web');


        let vRequestOptions = new RequestOptions({
            method: RequestMethod.Get,
            // body: body,
            url: vURL,
            headers: vRequestHeader
        });
        let vRequesObject = new Request(vRequestOptions);

        //process request
        this.request(vRequesObject).subscribe(
            (response) => {
                this.vIsRetrying = false;
                let vCurrentContext = this;

                // renew the token
                // let payload = JSON.parse(this._encryptionService.decrypt(response.json()));

                let payload;

                if (CONFIGURATION.ENCRYPTION.REQUEST) {
                    payload = JSON.parse(this._encryptionService.decrypt(response.text()));
                } else {
                    payload = response.json();
                }
                this._storageService.setToken('accessToken', payload.data.accessToken, true);
                this._storageService.setToken('idToken', payload.data.idToken, true);
                this._storageService.setToken('refreshToken', payload.data.refreshToken, true);
                // localStorage.setItem('accessToken', this._encryptionService.encryptStorage(newAccessToken));
                // localStorage.setItem('refreshToken', this._encryptionService.encryptStorage(newRefreshToken));

                // execute all pending retry request
                this.vHttpPendingRequestEvent.forEach(function (pRequestEvent, pIndex, pObject) {
                    vCurrentContext.executePendingRequest(pRequestEvent.request, pRequestEvent.observables);
                });
                this.vHttpPendingRequestEvent = [];
            },
            (error) => {
                // set all pending stack become failed
                // console.log('myhttp error: ', error.status);
                this.vIsRetrying = false; // can retry again after relogin
                let vCurrentContext = this;
                this.vHttpPendingRequestEvent.forEach(function (pRequestEvent, pIndex, pObject) {
                    vCurrentContext.handleHTTPError(error, pRequestEvent.observables);
                    // console.log('put all pending request as error');
                    // console.log('set : ' + pRequestEvent.url + ' pending request from stack became failed');
                });
                this.vHttpPendingRequestEvent = [];

                // failed to update token
                this._storageService.clearAll();
                this._storageService.clearAllSession();
                // localStorage.removeItem('accessToken');
                // localStorage.removeItem('refreshToken');
                // localStorage.removeItem('accountData');
                this._pageNavigationService.navigate(['login']);
                // console.log(' myhttp error nav to login page');
            }
        );

    }

}


// WEBPACK FOOTER //
// /home/maheshreddy/PRP_FE/src/app/shared/services/my-http.service.ts